module.exports = __webpack_public_path__ + "img/arrow_filling2.bffc5200.svg";